import "../statbox/StatBox.css";
import { Box, Typography } from "@mui/material";
import { Line } from "react-chartjs-2";
import { useNavigate } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement);

export default function StatBox({
  title,
  value,
  percent,
  graphData,
  color,
  icon,
  brim,
  route,
  timePeriod = "Bu ay",
}) {
  const navigate = useNavigate();

  const isPositive = typeof percent === "string" && percent.startsWith("+");

  const data = {
    labels: graphData?.map((_, idx) => idx + 1) || [],
    datasets: [
      {
        data: graphData || [],
        borderColor: isPositive ? "#4caf50" : "#f44336",
        borderWidth: 2,
        tension: 0.3,
        fill: false,
        pointRadius: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    interaction: {
      mode: null,
      intersect: false,
    },
    events: [],
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    scales: {
      x: { display: false },
      y: { display: false },
    },
  };

  const handleSeeAllClick = () => {
    if (!route) return;

    navigate(`/admin/${route.path}`, {
      state: {
        earningType: route.type,
      },
    });
  };


  return (
    <Box className="stat-box" style={{ borderTop: `4px solid ${color}` }}>

      <Box className="stat-box-top">
        <Box
          className="stat-box-icon"
          style={{ backgroundColor: color }}
        >
          <img
            src={icon}
            alt={title}
            draggable={false}
            className="stat-box-icon-img"
          />
        </Box>

        <Box className="stat-box-info">
          <Typography className="stat-box-title">
            {title}
          </Typography>
          <Typography className="stat-box-value">
            {value} {brim}
          </Typography>
        </Box>

        <Box className="stat-box-graph">
          <Line data={data} options={options} />
        </Box>
      </Box>


      <Box className="stat-box-bottom">
        <Typography
          className="stat-box-see-all"
          style={{
            color: color,
            cursor: route ? "pointer" : "default",
            opacity: route ? 1 : 0.6,
          }}
          onClick={handleSeeAllClick}
        >
          Hamısına nəzər yetir
        </Typography>

        <Box className="stat-box-percent-box">
          <Typography
            className={`stat-box-percent ${isPositive ? "positive" : "negative"
              }`}
          >
            {typeof percent === "string" && percent.includes("%")
              ? percent
              : `${percent}%`}
          </Typography>
          <Typography className="stat-box-month">
            {timePeriod}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
